import { render, staticRenderFns } from "./ElectronicBillingCard.vue?vue&type=template&id=06f083a6"
import script from "./ElectronicBillingCard.vue?vue&type=script&lang=js"
export * from "./ElectronicBillingCard.vue?vue&type=script&lang=js"
import style0 from "./ElectronicBillingCard.vue?vue&type=style&index=0&id=06f083a6&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports